<template>
  <div class="row">
    <OrderInfoItemWrapperComponent :data-class-name="'__data-1'"
                                   :translate-key="'pickup_and_return'">
      <template #icon-item>
        <img src="/assets/images/Framelocation-icon.png" alt="location">
      </template>
      <template #order-info>
        {{ orderData.destination.raw.name }}, {{ orderData.destination.raw.formatted_address }}
      </template>
    </OrderInfoItemWrapperComponent>
    <OrderInfoItemWrapperComponent :data-class-name="'__data-2'"
                                   :translate-key="'pick_up'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="pickup-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.pickupDate) + ' ' + orderData.pickupTime.replace(/\s/g, '') }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-3'"
                                   :translate-key="'passengers'">
      <template #icon-item>
        <img src="/assets/images/Framepeople-icon.png" alt="people-count">
      </template>
      <template #order-info>
        {{ orderData.passengerCount }}
      </template>
    </OrderInfoItemWrapperComponent>

    <OrderInfoItemWrapperComponent :data-class-name="'__data-4'"
                                   :translate-key="'return'">
      <template #icon-item>
        <img src="/assets/images/Framecalendar-icon.png" alt="end-date-time">
      </template>
      <template #order-info>
        {{ dateHelpers.dateToDisplay(orderData.endDate) + ' ' + orderData.endTime.replace(/\s/g, '') }}
      </template>
    </OrderInfoItemWrapperComponent>

  </div>

  <div class="col-sm-12 col-md-12 col-lg-11 hr-line"></div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
// @ts-ignore
import OrderInfoItemWrapperComponent from "../../orderInfoItemWrapper/OrderInfoItemWrapperComponent.vue";
import {dateHelpers} from "../../../../helpers/dateHelpers";
export default defineComponent({
  name: 'DriverFalseWrapperComponent',
  computed: {
    dateHelpers() {
      return dateHelpers
    }
  },
  components: {
    OrderInfoItemWrapperComponent
  },
  props: {
    orderData: {
      type: Object
    }
  },

  data() {
    return {};
  }
})
</script>

<style scoped>

</style>